import type { ImgHTMLAttributes } from 'react';

export function LogoMark(props: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <img
      src="/images/brand/logo-mark-gradient.png"
      alt=""
      aria-hidden="true"
      data-testid="logo-mark"
      decoding="async"
      {...props}
    />
  );
}
